// ------------------------------------------------------------
import { CSSProperties, ReactElement } from 'react';
import { Whisper, Popover as RsPopover } from 'rsuite';
// ------------------------------------------------------------
interface PopoverProps {
    outsideNode: ReactElement;
    boxNode: ReactElement;
    style?: CSSProperties;
    defaultOpen?: boolean;
    onClose?: () => void;
}
// ------------------------------------------------------------
export default function Popover(props: PopoverProps) {
    return <Whisper
        preventOverflow
        defaultOpen={props?.defaultOpen}
        placement='autoVerticalStart'
        trigger='click'
        onClose={props?.onClose}
        speaker={(p, r) => <RsPopover
            full
            ref={r}
            arrow={false}
            className={`${p?.className} rs-popover`}
            style={{
                ...props.style,
                left: p?.left,
                top: p?.top,
                border: 'none',
                zIndex: 20000
            }}>
            {props?.boxNode}
        </RsPopover>}>
        {props?.outsideNode}
    </Whisper>;
}
// ------------------------------------------------------------